module.exports = __webpack_public_path__ + "static/img/6.7e80d47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/lianxiang/6.png
// module id = QS0I
// module chunks = 0